import type { AssetAccount, CoinUtxo } from '@ducat-unit/core';

import type { SnapWalletInventory } from './connector-metamask-snap';

export function toSafeNumber(value: string, label: string): number {
  const amount = Number(value);
  if (!Number.isSafeInteger(amount) || amount < 0 || String(amount) !== value) {
    throw new Error(`${label} is outside the safe construction range.`);
  }
  return amount;
}

export function snapInventoryFunds(inventory: SnapWalletInventory): CoinUtxo[] {
  return inventory.btcUtxos.map((row) => ({ txid: row.txid, vout: row.vout, value: row.valueSats, script_pk: row.scriptPubKey }));
}

export function snapInventoryAssets(inventory: SnapWalletInventory): AssetAccount[] {
  return inventory.unitUtxos.map((row) => ({
    asset_id: row.assetId,
    asset_balance: toSafeNumber(row.activeAmount, 'UNIT active amount'),
    asset_reserve: toSafeNumber(row.reservedAmount, 'UNIT reserved amount'),
    coin_id: row.coinId,
    coin_script: row.scriptPubKey,
    coin_value: row.coinValueSats,
  }));
}
